import Vue from 'vue';
import '@fortawesome/fontawesome-pro/css/fontawesome.css';
import '@fortawesome/fontawesome-pro/css/brands.css';
import '@fortawesome/fontawesome-pro/css/solid.css';
import '@fortawesome/fontawesome-pro/css/regular.css';
import '@fortawesome/fontawesome-pro/css/light.min.css';
import '@fortawesome/fontawesome-pro/css/duotone.css';

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async (/* { app, router, Vue ... } */) => {
  // Overwrite Quasar icon set default icons (uses Material by default)
  Vue.prototype.$q.iconSet.chip.remove = 'fas fa-times-circle';
  Vue.prototype.$q.iconSet.field.clear = 'fas fa-times-circle';

  /* 
  If we switch icon set from Material to Font Awesome in quasar.conf, we'll need to config icons here for things like pagination, dropdown, expansion items, etc., because Quasar uses light (fal) icon styles by default
  https://github.com/quasarframework/quasar/blob/v1/ui/icon-set/fontawesome-v5-pro.js

  Examples:

  Vue.prototype.$q.iconSet.arrow.dropdown = 'fas fa-caret-down';
  Vue.prototype.$q.iconSet.expansionItem.icon = 'fas fa-chevron-down';
  Vue.prototype.$q.iconSet.pagination.first = 'fas fa-step-backward';
  Vue.prototype.$q.iconSet.table.firstPage = 'far fa-step-backward';
  */
};
